import { TinyMce } from './tiny-mce.interface'

export class TinyMceHelper {

  private _tinyMceInstance: TinyMce

  constructor(tinyMceModule: TinyMce) {
    if (!tinyMceModule) {
      throw new Error('Cannot retrieve TinyMCE instance!')
    }
    this._tinyMceInstance = tinyMceModule
  }

  public get instance(): TinyMce {
    return this._tinyMceInstance
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/form/tiny-mce/tiny-mce-helper/tiny-mce-helper.ts